import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hero-card" }
const _hoisted_2 = { class: "hero-avatar" }
const _hoisted_3 = { class: "hero-title" }
const _hoisted_4 = { class: "hero-subtitle" }
const _hoisted_5 = { class: "hero-amount" }
const _hoisted_6 = { class: "hero-interval text-capitalize" }
const _hoisted_7 = {
  key: 0,
  class: "hero-highlight"
}
const _hoisted_8 = {
  key: 1,
  class: "feature-list"
}
const _hoisted_9 = { class: "feature-text" }

import { computed } from "vue";
import AppCard from "@/shared/components/ui/AppCard.vue";
import { formatCurrency } from "@/shared/utils/utils";

type DetailStatus = "Active" | "Paused" | "Inactive" | string;

type SubscriptionDetailResponse = {
  recurring_subscription?: {
    id: string | number;
    status: DetailStatus;
    billing_interval: string | null;
    interval_count: number | null;
    start_date: string | null;
    end_date: string | null;
    next_billing_date: string | null;
    metadata: unknown;
  };
  package?: {
    id: string | number | null;
    name: string | null;
    package_type: string | null;
    highlight: string | null;
    features: string[] | null;
  };
  plan?: {
    id: string | number | null;
    amount: number | string | null;
    type_name: string | null;
    currency: string | null;
  };
  vendor?: {
    id: string | number | null;
    name: string | null;
    logo: string | null;
  };
  company?: {
    id: string | number | null;
    code: string | null;
    name: string | null;
    logo: string | null;
  };
};


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionDetailHeroCard',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const featureItems = computed(() =>
  Array.isArray(props.detail.package?.features)
    ? props.detail.package.features.filter(Boolean)
    : String((props.detail.package as { feature?: string | null } | undefined)?.feature ?? "")
        .split(/[,\n;]/)
        .map((item) => item.trim())
        .filter(Boolean),
);


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_icon, {
        size: "32",
        color: "success"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("mdi-sync-circle", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.detail.package?.name || "Subscription"), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.detail.plan?.amount != null ? _unref(formatCurrency)(Number(__props.detail.plan.amount)) : "-"), 1),
      _createElementVNode("div", _hoisted_6, "per " + _toDisplayString(__props.detail.recurring_subscription?.billing_interval || "-"), 1)
    ]),
    (__props.detail.package?.highlight)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.detail.package.highlight), 1))
      : _createCommentVNode("", true),
    (featureItems.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "feature-title text-success" }, "Features:", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureItems.value, (feature) => {
            return (_openBlock(), _createElementBlock("div", {
              key: feature,
              class: "feature-item"
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "success",
                class: "feature-icon"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-check-circle-outline", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_9, _toDisplayString(feature), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})